/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Password_Reset_Sent_BodyInputs */

const en_password_reset_sent_body = /** @type {(inputs: Password_Reset_Sent_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open the link we sent to this address to set a new password.`)
};

const es_password_reset_sent_body = /** @type {(inputs: Password_Reset_Sent_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abre el enlace que enviamos a esta dirección para crear una contraseña nueva.`)
};

/**
* | output |
* | --- |
* | "Open the link we sent to this address to set a new password." |
*
* @param {Password_Reset_Sent_BodyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const password_reset_sent_body = /** @type {((inputs?: Password_Reset_Sent_BodyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Password_Reset_Sent_BodyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_password_reset_sent_body(inputs)
	return en_password_reset_sent_body(inputs)
});